import { CharRenderInfo } from "./CharRenderInfo";
import { TextRenderConfig } from "./TextRenderConfig";
var pixelBBX = [0, 0, 0, 0];
const tmpRI = new CharRenderInfo();
export class MeasureFont {
    constructor(charRender) {
        this.charRender = charRender;
    }
    getFontSizeInfo(font, size) {
        let fontstr = 'bold ' + size + 'px ' + font;
        if (!TextRenderConfig.useImageData) {
            let fontSizeW = this.charRender.getWidth(fontstr, '有') * 1.5;
            let fontSizeH = size * 1.5;
            var szinfo = fontSizeW << 8 | fontSizeH;
            return szinfo;
        }
        pixelBBX[0] = size / 2;
        pixelBBX[1] = size / 2;
        pixelBBX[2] = size;
        pixelBBX[3] = size;
        var orix = 16;
        var oriy = 16;
        var marginr = 16;
        var marginb = 16;
        this.charRender.scale(1, 1);
        tmpRI.height = size;
        this.charRender.fontsz = size;
        var bmpdt = this.charRender.getCharBmp('g', fontstr, 0, 'red', null, tmpRI, orix, oriy, marginr, marginb);
        this.bmpData32 = new Uint32Array(bmpdt.data.buffer);
        this.updateBbx(bmpdt, pixelBBX, false);
        bmpdt = this.charRender.getCharBmp('有', fontstr, 0, 'red', null, tmpRI, oriy, oriy, marginr, marginb);
        this.bmpData32 = new Uint32Array(bmpdt.data.buffer);
        if (pixelBBX[2] < orix + tmpRI.width)
            pixelBBX[2] = orix + tmpRI.width;
        this.updateBbx(bmpdt, pixelBBX, false);
        var xoff = Math.max(orix - pixelBBX[0], 0);
        var yoff = Math.max(oriy - pixelBBX[1], 0);
        var bbxw = pixelBBX[2] - pixelBBX[0];
        var bbxh = pixelBBX[3] - pixelBBX[1];
        var sizeinfo = xoff << 24 | yoff << 16 | bbxw << 8 | bbxh;
        return sizeinfo;
    }
    checkBmpLine(data, l, sx, ex) {
        if (this.bmpData32.buffer != data.data.buffer) {
            this.bmpData32 = new Uint32Array(data.data.buffer);
        }
        var stpos = data.width * l + sx;
        for (var x = sx; x < ex; x++) {
            if (this.bmpData32[stpos++] != 0)
                return true;
        }
        return false;
    }
    updateBbx(data, curbbx, onlyH = false) {
        var w = data.width;
        var h = data.height;
        var x = 0;
        var sy = curbbx[1];
        var ey = 0;
        var y = sy;
        if (this.checkBmpLine(data, sy, 0, w)) {
            while (true) {
                y = (sy + ey) / 2 | 0;
                if (y + 1 >= sy) {
                    curbbx[1] = y;
                    break;
                }
                if (this.checkBmpLine(data, y, 0, w)) {
                    sy = y;
                }
                else {
                    ey = y;
                }
            }
        }
        if (curbbx[3] > h)
            curbbx[3] = h;
        else {
            y = sy = curbbx[3];
            ey = h;
            if (this.checkBmpLine(data, sy, 0, w)) {
                while (true) {
                    y = (sy + ey) / 2 | 0;
                    if (y - 1 <= sy) {
                        curbbx[3] = y;
                        break;
                    }
                    if (this.checkBmpLine(data, y, 0, w)) {
                        sy = y;
                    }
                    else {
                        ey = y;
                    }
                }
            }
        }
        if (onlyH)
            return;
        var minx = curbbx[0];
        var stpos = w * curbbx[1];
        for (y = curbbx[1]; y < curbbx[3]; y++) {
            for (x = 0; x < minx; x++) {
                if (this.bmpData32[stpos + x] != 0) {
                    minx = x;
                    break;
                }
            }
            stpos += w;
        }
        curbbx[0] = minx;
        var maxx = curbbx[2];
        stpos = w * curbbx[1];
        for (y = curbbx[1]; y < curbbx[3]; y++) {
            for (x = maxx; x < w; x++) {
                if (this.bmpData32[stpos + x] != 0) {
                    maxx = x;
                    break;
                }
            }
            stpos += w;
        }
        curbbx[2] = maxx;
    }
}
